import { PAYMENT_CALLBACK_DISCRIMINATOR } from '@/shared/common/constants/paymentCallback.constant';

export const INSWITCH_CARD_ICON = 'solid credit-card' as const;

export const INSWITCH_PARTNER_NAME = 'INSWITCH';

export const INSWITCH_SESSION_KEYS = {
  TRANSACTION_REFERENCE: 'inswitch_transaction_reference',
} as const;

export const INSWITCH_CALLBACK_QUERY_SUCCESS = PAYMENT_CALLBACK_DISCRIMINATOR.INSWITCH_SUCCESS;
export const INSWITCH_CALLBACK_QUERY_ERROR = PAYMENT_CALLBACK_DISCRIMINATOR.INSWITCH_ERROR;

export const INSWITCH_CALLBACK_OUTCOME = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

export const INSWITCH_CALLBACK_PATH_PREFIX = '/payment-callback/inswitch';

export const INSWITCH_CALLBACK_ROUTE_PATH = `${INSWITCH_CALLBACK_PATH_PREFIX}/:outcome`;

export const INSWITCH_CALLBACK_ROUTE_NAME = 'inswitch-payment-callback';

export const INSWITCH_B2B_TRANSACTION_STATUS = {
  FINISHED: 'finished',
  CANCELLED: 'cancelled',
} as const;

export const INSWITCH_PAYMENT_UI_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
  CONNECTION_ERROR: 'connectionError',
} as const;

export const INSWITCH_ALLOWED_BY_CURRENCY: readonly string[] = [
  'CLP',
  'COP',
] as const;

export const INSWITCH_CUSTOMER_TYPE = 'COMPANY';
export const INSWITCH_PRODUCT_TYPE = 'PPC';

export const INSWITCH_PROHIBITED_COUNTRIES: readonly string[] = [
  'AF',
  'AL',
  'DZ',
  'AS',
  'AO',
  'AI',
  'BS',
  'BH',
  'BB',
  'BY',
  'BM',
  'BO',
  'BA',
  'BW',
  'VG',
  'BG',
  'BF',
  'BI',
  'KH',
  'CM',
  'KY',
  'CF',
  'TD',
  'CD',
  'CG',
  'CU',
  'CY',
  'DM',
  'EG',
  'ET',
  'FK',
  'FJ',
  'GA',
  'GH',
  'GI',
  'GU',
  'GG',
  'GN',
  'GW',
  'GY',
  'HT',
  'IN',
  'ID',
  'IR',
  'IQ',
  'IM',
  'CI',
  'JM',
  'JE',
  'JO',
  'KE',
  'KP',
  'KG',
  'LA',
  'LB',
  'LR',
  'LY',
  'MK',
  'MG',
  'MV',
  'ML',
  'MU',
  'MD',
  'MC',
  'MN',
  'ME',
  'MA',
  'MZ',
  'MM',
  'NA',
  'NR',
  'NP',
  'NG',
  'MP',
  'PK',
  'PW',
  'PS',
  'PG',
  'PH',
  'RU',
  'RW',
  'WS',
  'ST',
  'SN',
  'RS',
  'SC',
  'SL',
  'SB',
  'SO',
  'ZA',
  'SS',
  'LK',
  'SD',
  'SR',
  'SZ',
  'SY',
  'TZ',
  'TT',
  'TN',
  'TR',
  'TC',
  'UG',
  'UA',
  'AE',
  'VU',
  'VE',
  'VN',
  'VI',
  'YE',
  'ZW',
];

export const INSWITCH_RESTRICTED_ACTIVITY_IDS: readonly number[] = [
  109, 153, 184, 56, 58, 61, 163, 168, 177, 181,
];

export const INSWITCH_METHOD_NAMES: readonly string[] = [
  'INSWITCHCLP',
  'INSWITCHCOP',
] as const;

export const INSWITCH_PAY_IN_REFERENCE_FIELDS: readonly string[] = [
  'partnerOrderId',
  'transactionReference',
  'referenceCode',
  'id',
  'paymentId',
  'reference',
];
